import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Card, LogButton } from './common';

import rightArrow from '../../images/common/arrow-right-black.svg';
import ClockIcon from '../../images/health-content/clock-icon.svg';
import HbA1cIcon from '../../images/health-content/hbA1c-icon.svg';
import Hba1cModal from './Hba1cModal';

const Hba1cCard = ({ hbA1cCard }) => {
  const history = useHistory();
  const [showModal, setShowModal] = useState({
    showHbA1cModal: false,
  });
  return (
    <Card
      onClick={() => history.push('/health-content/hbA1c-data')}
      className="w-half p-15 mt-2 health-card flex flex-col justify-between"
    >
      <div>
        <div className="flex justify-between w-full">
          <img src={HbA1cIcon} alt="weight-icon" />
          <span
            className="rounded-full text-title-m font-semibold px-2 mt-0.5 mr-2"
            style={{ transform: 'scale(.5, 1)' }}
          >
            &gt;
          </span>
        </div>
        <h4 className="text-caption-l font-semibold mt-10">hbA1c</h4>
        <h1 className="text-title-l font-bold mt-1">
          {hbA1cCard ? hbA1cCard.value1 : 0}
        </h1>
        {hbA1cCard && (
          <p className="font-medium text-chip text-sub mt-1">
            <img src={ClockIcon} alt="clock" className="inline" />
            &nbsp;{hbA1cCard ? hbA1cCard.measuredOn : ''}
          </p>
        )}
      </div>
      {/* <button
        onClick={(e) => {
          e.stopPropagation();
          setShowModal((prevState) => ({
            ...prevState,
            showHbA1cModal: true,
          }));
          setModalState('open');
        }}
        className="flex justify-center items-center w-100 bg-txtlight-shades4 rounded-lg text-caption-l font-semibold py-2.5  mt-10"
      >
        <img src={AddIcon} alt=""></img>
        <span className="ml-8px">Log New</span>
      </button> */}
      <LogButton
        buttonText="Log New"
        onClick={(e) => {
          setShowModal((prevState) => ({
            ...prevState,
            showHbA1cModal: true,
          }));
        }}
      />
      {showModal.showHbA1cModal && (
        <Hba1cModal
          // getData={getData}
          hideModal={(e) => {
            if (e) e.stopPropagation();
            setShowModal((prevState) => ({
              ...prevState,
              showHbA1cModal: false,
            }));
          }}
          measuredOn={hbA1cCard ? hbA1cCard.measuredOn : ''}
        />
      )}
    </Card>
  );
};

export default Hba1cCard;
